import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import resolveBrandLogo from '%evp_theme/brandbook/v20/brandLogo';
import isHighContrastTheme from '%evp_theme/brandbook/appearance/isHighContrastTheme';
import isDarkTheme from '%evp_theme/brandbook/appearance/isDarkTheme';

export const LOGO_ASPECT_RATIO = '1242 / 321';
export const LOGO_DISPLAY_HEIGHT = { xs: 28, md: 36 };
export const LOGO_DISPLAY_WIDTH = { xs: 108, md: 139 };

const LOGO_IMAGE_SX = {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'contain',
};

function PayseraTicketsLogo({ href = '/', title = 'Paysera Tickets' }) {
    const theme = useTheme();
    const brandLogo = resolveBrandLogo(isDarkTheme(theme), isHighContrastTheme(theme));

    return (
        <Box
            component="a"
            href={href}
            aria-label={title}
            data-testid="redesign-header-logo"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                textDecoration: 'none',
                color: 'inherit',
                flexShrink: 0,
                height: LOGO_DISPLAY_HEIGHT,
                width: LOGO_DISPLAY_WIDTH,
            }}
        >
            <Box
                component="img"
                src={brandLogo.src}
                alt=""
                aria-hidden="true"
                sx={{ ...LOGO_IMAGE_SX, ...brandLogo.style }}
            />
        </Box>
    );
}

PayseraTicketsLogo.propTypes = {
    href: PropTypes.string,
    title: PropTypes.string,
};

export default PayseraTicketsLogo;
